/** Kept apart from the banner so the header can use it without loading it. */
export const EDF_GUIDE_URL =
  'https://blog.remitcircle.com/education/edf-for-service-exporters-rbi-rules-deadlines-steps-2026/';
